module.exports = __webpack_public_path__ + "img/map_1.0fae24b6.png";